"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
const common_1 = require("@becrop/components/Toolkit/Heatmap2/models/common");
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
class GroupConfig {
    constructor() {
        // The type of filter
        this.type = 'boolean';
        // The data origin: core, csv or ranks
        this.origin = 'core';
        // The unique ID - lang independent
        this.id = '';
        // The name
        this.name = '';
        // The path to retrieve the value in the sample object, or csv, or ranks
        this.sample_path = '';
        this.enabled = true;
        this.option_label_fn = common_1.identify_fn;
        //
        // Ranks
        //
    }
    get has_extra_num_of_groups() {
        return this.type === 'number' || this.type === 'date';
    }
    update(library) {
        if (!library.length) {
            this.enabled = false;
            return;
        }
        const options = library
            .map(s => s.retrieveValueForFilterOrGroup(this))
            .filter(o => o !== undefined && o !== null)
            .filter(onlyUnique);
        this.enabled = options.length > 1;
    }
    //
    // Core
    //
    static newCore(type, id, path) {
        const f = new GroupConfig();
        f.type = type;
        f.id = id;
        f.name = (0, trans_1.trans)('heatmap.metadata_items.' + id);
        f.sample_path = path;
        f.origin = 'core';
        return f;
    }
    static newCoreBoolean(id, path) {
        return GroupConfig.newCore('boolean', id, path);
    }
    static newCoreList(id, path, labels = common_1.identify_fn) {
        const config = GroupConfig.newCore('list', id, path);
        if (labels)
            config.option_label_fn = labels;
        return config;
    }
    static newCoreNumber(id, path) {
        return GroupConfig.newCore('number', id, path);
    }
    static newCoreDate(id, path) {
        return GroupConfig.newCore('date', id, path);
    }
    //
    // CSV
    //
    static newCSV(type, id, name) {
        const f = new GroupConfig();
        f.type = type;
        f.id = id;
        f.name = name;
        f.origin = 'csv';
        return f;
    }
}
exports.default = GroupConfig;
